import { Dispatch } from 'redux';
import { IResponse, RACARequest } from '../../../Request';
import { endLoading, startLoading } from '../../../../store/slices/loadingSlice';
import requestMiddlewares from '../../../requestMiddlewares';

export default async function findPublicTalentsByBusinessLineRequest(
  dispatch: Dispatch,
  companyId: string,
  businessLine: string,
): Promise<IResponse> {
  dispatch(startLoading());

  const request = new RACARequest('publicTalents', 'listByBusinessLine')
    .setPathValues('COMPANY_ID', companyId)
    .setPathValues('BUSINESS_LINE', businessLine);

  const response = await request.makeRequest();
  requestMiddlewares(dispatch, response);

  dispatch(endLoading());

  return response;
}
